function marquee() {
  $(".announcement--scrolling__row").slick({
  speed: 4e3,
  autoplay: !0,
  autoplaySpeed: 0,
  centerMode: !0,
  cssEase: "linear",
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: !0,
  infinite: !0,
  initialSlide: 1,
  arrows: !1,
  buttons: !1,
});
}
document.addEventListener("DOMContentLoaded", function() {
  marquee();
});

document.addEventListener("shopify:section:load", function(event) { 
 marquee();
});

$(".arrow--wrapper").on("click", function () {
$(this).hasClass("arrow-prev")
  ? $(this)
      .parents(".slider-mobile-gutter")
      .find(".slider-button--prev")
      .click()
  : $(this)
      .parents(".slider-mobile-gutter")
      .find(".slider-button--next")
      .click();
});
function collectionSlider(selector,settings){
  $(selector).slick(settings);
}

// $(document).ready(function() {
//   const appwidgetLoad = setTimeout(function(){
//     var appwidget = $('.gpo-choicelist');
//     if(appwidget.length > 0){
//       appwidget.each(function(){
//         let targetElement = $(this).find('input[type="checkbox"]');
//         // console.log(targetElement);
//         if(targetElement.is(":checked")){
//           targetElement.trigger('click');
//         }else{
          
//         }
//       });
//        clearTimeout(appwidgetLoad);
//     }
//   }, 1000); 
// });

$(document).ready(function(){
  const appwidgetsElement = setInterval(function() {
    var appwidget = $('.gpo-element');
        if(appwidget.length > 0){
          appwidget.each(function(){
            let label = $(this).find('.label-content').text();
            console.log(label);
            if(label == "Stool Selection (Optional)"){
              $(this).addClass('stool--wrapper')
            }
          });
          clearTimeout(appwidgetsElement);
        }
  }, 1000);
});
//# sourceMappingURL=/cdn/shop/t/5/assets/custom.js.map?v=180461305140397812711741277021
